import React from "react";
import Layout from "./Layout";

const ReportGenerator = () => {
  const handleGenerateReport = (category) => {
    alert(`Report for ${category} generated!`);
  };

  return (
    <Layout>
      <div className="p-6 bg-white rounded-lg shadow-lg">
        {/* Header */}
        <h2 className="text-2xl font-bold text-gray-800 mb-6">
          Generate Reports
        </h2>

        {/* Description */}
        <p className="text-gray-600 mb-4">
          Select a schedule below to generate detailed compliance reports.
        </p>

        {/* Buttons Section */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <button
            onClick={() => handleGenerateReport("Schedule H")}
            className="bg-blue-600 text-white py-3 px-6 rounded-lg shadow-md hover:bg-blue-700 hover:shadow-lg transition-all duration-200"
          >
            Schedule H Report
          </button>
          <button
            onClick={() => handleGenerateReport("Schedule H1")}
            className="bg-blue-600 text-white py-3 px-6 rounded-lg shadow-md hover:bg-blue-700 hover:shadow-lg transition-all duration-200"
          >
            Schedule H1 Report
          </button>
          <button
            onClick={() => handleGenerateReport("Schedule X")}
            className="bg-blue-600 text-white py-3 px-6 rounded-lg shadow-md hover:bg-blue-700 hover:shadow-lg transition-all duration-200"
          >
            Schedule X Report
          </button>
        </div>

        {/* Footer Section */}
        <div className="mt-6 text-gray-500">
          <p>
            Reports include detailed compliance status and prescription
            requirements for the selected schedule.
          </p>
          <p className="italic">Contact support if you face any issues.</p>
        </div>
      </div>
    </Layout>
  );
};

export default ReportGenerator;
